<template>
  <div>
    <v-data-table
      :loading="!!!items.length"
      :headers="headers"
      :items="items"
      :items-per-page="10"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options.sync="options"
      :sort-by="sortBy"
    >
      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          route-name="abo-services.show"
          :route-params="{ id: item.id }"
          @show="$emit('show', item)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'AboServicesList',
  components: { ActionSlotComponent },
  mixins: [i18nRefreshData],

  props: {
    items: {
      type: Array,
      default: () => []
    },
    meta: {
      type: Object,
      default: () => ({
        total: 0
      })
    },
    filters: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    options: {},
    sortBy: 'title',
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    }
  }),

  computed: {
    params() {
      const options = this.options;

      return {
        page: options.page,
        per_page: options.itemsPerPage,
        sort_by: options.sortBy[options.sortBy.length - 1],
        order_by: options.sortDesc[options.sortDesc.length - 1] ? 'desc' : 'asc'
      };
    },
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.TITLE'),
          sortable: true,
          value: 'title'
        },
        {
          text: this.$t('ITEM.TYPE'),
          sortable: false,
          value: 'type.name'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  },

  watch: {
    options: {
      handler() {
        this.refreshData();
      },
      deep: true
    },
    filters: {
      handler() {
        this.options.page = 1;
        this.refreshData();
      },
      deep: true
    }
  },

  methods: {
    refreshData() {
      this.$emit('refresh', {
        params: Object.assign({}, this.filters, this.params)
      });
    }
  }
};
</script>
